// material-ui
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function Footer() {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      sx={{
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: "space-between",
        p: "24px 16px 0px",
        mt: "auto",
        gap: { xs: 1.5, md: 0 },
      }}
    >
      <Typography variant="caption">
        &copy; All rights reserved{" "}
        <Link href="https://www.deliverit.net.in/" target="_blank" underline="hover">
          Deliverit By Urban Harvest
        </Link>
      </Typography>
      <Stack
        direction="row"
        sx={{
          gap: 1.5,
          alignItems: "center",
          justifyContent: { xs: "flex-start", md: "space-between" },
          flexWrap: "wrap",
        }}
      >
        <Link href="https://www.deliverit.net.in/about-us" target="_blank" variant="caption" color="text.primary">
          About us
        </Link>
        <Link href="https://www.deliverit.net.in/privacy-policy" target="_blank" variant="caption" color="text.primary">
          Privacy Policy
        </Link>
        <Link href="https://www.deliverit.net.in/terms-conditions" target="_blank" variant="caption" color="text.primary">
          Terms & Conditions
        </Link>
      </Stack>
    </Stack>
  );
}
